module.exports = __webpack_public_path__ + "media/sounds_answered.60145df2.mp3";